module.exports = __webpack_public_path__ + "images/7023d21.png";